import { merge } from 'lodash';

class InvalidConfigError extends Error {}

export default ({
  config,
  appName,
  requiredConfigKeys = [],
  optionalConfigKeys = [],
  defaultValues = {},
}) => {
  const newConfig = merge({}, defaultValues, config);
  const configKeys = requiredConfigKeys.concat(optionalConfigKeys);

  requiredConfigKeys.forEach((key) => {
    if (!(key in newConfig)) {
      throw new InvalidConfigError(`Missing config in ${appName}: ${key}`);
    }
  });

  Object.keys(newConfig).forEach((key) => {
    if (!configKeys.includes(key)) {
      throw new InvalidConfigError(`Unknown config key in ${appName}: ${key}`);
    }
  });

  return newConfig;
};
